import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconSocialLinkedInSvg } from "./IconSocialLinkedInSvg.mjs";
const IconSocialLinkedIn = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconSocialLinkedInSvg, ...svgProps }) });
export {
  IconSocialLinkedIn
};
